"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debounce_1 = __importDefault(require("lodash/debounce"));
const map_1 = __importDefault(require("lodash/map"));
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const DispatchContext_1 = require("../context/DispatchContext");
const Alert_1 = require("../elements/popup/Alert");
const Panels_1 = require("../panels/Panels");
const ToolTypes_1 = require("../toolbar/ToolTypes");
function useToolsFunctions() {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const alert = (0, Alert_1.useAlert)();
    const { open: openPanel } = (0, ui_1.useToggleAccordion)();
    const [isRealSpectrumShown, setIsRealSpectrumShown] = (0, react_1.useState)(false);
    const debounceClickEventsRef = (0, react_1.useRef)({ clicks: [] });
    const handleChangeOption = (0, react_1.useCallback)((selectedTool) => {
        if ([
            ToolTypes_1.options.peakPicking.id,
            ToolTypes_1.options.integral.id,
            ToolTypes_1.options.zonePicking.id,
            ToolTypes_1.options.exclusionZones.id,
            ToolTypes_1.options.rangePicking.id,
        ].includes(selectedTool)) {
            alert.show('Press Shift + Left Mouse button to select zone');
        }
        if (Object.keys(Panels_1.TOOLS_PANELS_ACCORDION).includes(selectedTool)) {
            openPanel(Panels_1.TOOLS_PANELS_ACCORDION[selectedTool]);
        }
        dispatch({
            type: 'SET_SELECTED_TOOL',
            payload: { selectedTool: selectedTool || ToolTypes_1.options.zoom.id },
        });
    }, [alert, dispatch, openPanel]);
    const handleFullZoomOut = (0, react_1.useCallback)(() => {
        if (debounceClickEventsRef.current.clicks.length === 0) {
            dispatch({
                type: 'FULL_ZOOM_OUT',
                payload: { zoomType: 'FULL' },
            });
        }
        const callback = (0, debounce_1.default)(() => {
            debounceClickEventsRef.current.clicks = [];
        }, 500);
        debounceClickEventsRef.current.clicks.push(callback);
        callback();
        if (debounceClickEventsRef.current.clicks.length > 1) {
            (0, map_1.default)(debounceClickEventsRef.current.clicks, (debounce) => debounce.cancel());
            debounceClickEventsRef.current.clicks = [];
            dispatch({
                type: 'FULL_ZOOM_OUT',
                payload: {},
            });
        }
    }, [dispatch, debounceClickEventsRef]);
    const changeDisplayViewModeHandler = (0, react_1.useCallback)(() => {
        dispatch({
            type: 'CHANGE_SPECTRUM_DISPLAY_VIEW_MODE',
        });
    }, [dispatch]);
    const changeSpectrumViewHandler = (0, react_1.useCallback)(() => {
        dispatch({
            type: 'TOGGLE_REAL_IMAGINARY_VISIBILITY',
        });
        setIsRealSpectrumShown(!isRealSpectrumShown);
    }, [dispatch, isRealSpectrumShown]);
    const alignSpectrumsVerticallyHandler = (0, react_1.useCallback)(() => {
        dispatch({
            type: 'SET_SPECTRUMS_VERTICAL_ALIGN',
        });
    }, [dispatch]);
    return {
        handleChangeOption,
        handleFullZoomOut,
        changeDisplayViewModeHandler,
        changeSpectrumViewHandler,
        alignSpectrumsVerticallyHandler,
        isRealSpectrumShown,
    };
}
exports.default = useToolsFunctions;
